module.exports = __webpack_public_path__ + "img/desktop.3f0cdb69.png";